import * as i0 from "@angular/core";
export class ReservationIdService {
    constructor() { }
    setId(reservationId) {
        this.reservationId = Number(reservationId);
    }
    getId() {
        return this.reservationId;
    }
}
ReservationIdService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReservationIdService_Factory() { return new ReservationIdService(); }, token: ReservationIdService, providedIn: "root" });
